import gsap from 'gsap'
import { store, math } from "../core/store"
import { events } from "../core/store"

export class BeforeAfterSliders {
  constructor() {
    this.beforeAfters = [...document.querySelectorAll('.js-before-after')]

    if (this.beforeAfters.length <= 0) { return false }

    this.beforeAfters.forEach(beforeAfter => {
      new BeforeAfter(beforeAfter)
    })
  }
}

class BeforeAfter{
  constructor(item) {
    this.item = item
    this.dragger = this.item.querySelector('.js-before-after-dragger')
    this.draggerWrapper = this.item.querySelector('.js-before-after-dragger-container')
    this.circle = this.item.querySelector('.js-before-after-dragger-circle')
    this.after = this.item.querySelector('.js-before-after-after')
    this.afterInner = this.item.querySelector('.js-before-after-after-inner')
    this.progress = this.item.querySelector('.before-after__dragger__line--progress')
    this.intro = this.item.dataset.intro
    this.image = this.item.querySelector('.before-after__before img')
    this.image2 = this.item.querySelector('.js-before-after-after img')

    this.progressValue = 1
    this.newProgressValue = 1
    this.isPulsing = false

    this.isDown = false

    this.init()
  }

  init = () => {
    if (this.intro === 'true') {
      this.playIntro()
      this.createTimeline()
    } else {
      // this.setDragger()
    }
    this.createPulsingTimeline()
    this.bindEvents()
  }

  bindEvents = () => {
    this.dragger.addEventListener(events.dragStart, (e) => {
      this.isDown = true

      gsap.to(this.circle, {
        scale: 1.1,
        duration: 0.4,
        ease: 'power2.out',
      })
      this.isPulsing = false
      this.pulseTimeline.pause()
    })

    document.addEventListener(events.dragEnd, (e) => {
      this.isDown = false

      gsap.to(this.circle, {
        scale: 1,
        duration: 0.4,
        ease: 'power2.out',
      })
    })

    document.addEventListener(
      events.drag,
      (e) => {
        if (this.isDown) {
          let left = this.draggerWrapper.getBoundingClientRect().x
          let width = this.draggerWrapper.getBoundingClientRect().width

          if (store.isDevice) {
            this.startValue = e.touches[0].clientX
          } else {
            this.startValue = e.clientX
          }

          let valueX = ((this.startValue - left) / width) * 100

          valueX = valueX < 0 ? 0 : valueX
          valueX = valueX > 100 ? 100 : valueX

          this.after.style.transform = `translate(-${100 - valueX}%, 0)`
          this.afterInner.style.transform = `translate(${100 - valueX}%, 0)`

          if (this.progress) {
            this.progress.style.clipPath = `polygon(0 0, ${valueX}% 0, ${valueX}% 100%, 0 100%)`
          }

          let draggerValueX = width * ((this.startValue - left) / width)

          this.progressValue = valueX / 100

          draggerValueX = draggerValueX < 0 ? 0 : draggerValueX
          draggerValueX = draggerValueX > width ? width : draggerValueX

          if (this.intro === 'true') {
            this.dragger.style.transform = `translate(${draggerValueX}px, 0)`
          } else {
            this.dragger.style.transform = `translate(${draggerValueX - (width / 2)}px, 0)`
          }
        }
      },
      true
    )
  }

  createTimeline = () => {
    this.timeline = gsap.timeline({ paused: true })

    this.timeline
      .to(
        this.image,
        {
          scale: 1.025,
          opacity: 1,
        },
        0
      )
      .to(
        this.image2,
        {
          scale: 1.025,
          opacity: 1,
        },
        0
      )
  }

  createPulsingTimeline = () => {
    this.pulseTimeline = gsap.timeline({
      ease: 'expo.out',
      repeat: -1,
      delay: 2,
      repeatDelay: 2,
      onComplete: () => {
        if (this.isPulsing) {
          this.pulseTimeline.restart()
        }
      }
     })

    this.pulseTimeline.to(this.dragger, {
      scale: 1.2
    }, 0)
    .to(this.dragger, {
      scale: 1
    }, 1)
  }

  playIntro = () => {
    this.tl = gsap.timeline({ delay: 1 })
    const duration = 3

    this.tl.to(this.after, {
      xPercent: 100,
      duration,
      ease: 'power3.inOut'
    }, 'a')
    .to(this.afterInner, {
      xPercent: -100,
      duration,
      ease: 'power3.inOut',
    }, 'a')
    .to(this.dragger, {
      x: this.draggerWrapper.getBoundingClientRect().width,
      duration,
      ease: 'power3.inOut',
    }, 'a')
    .to(this.progress, {
      clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%',
      duration,
      ease: 'power3.inOut',
      onComplete: () => {
        this.resetIntroValues()
        this.render()
      },
      onUpdate: () => {
        this.timeline.progress(this.tl.time() / duration)
      }
    }, 'a')
  }

  resetIntroValues = () => {
    this.after.style.transform = `translate(0, 0)`
    this.afterInner.style.transform = `translate(0, 0)`
    this.dragger.style.transform = `translate(${(this.draggerWrapper.getBoundingClientRect().width / 16)}rem, 0)`
  }

  setDragger = () => {
    gsap.set(this.dragger, {
      x: this.draggerWrapper.getBoundingClientRect().width / 2
    })
  }

  render = () => {
    this.newProgressValue = math.lerp(this.newProgressValue, this.progressValue, 0.05)
    this.timeline.progress(this.newProgressValue)

    window.requestAnimationFrame(this.render)
  }
}
